export default __webpack_public_path__ + "static/media/mlgu_seal.8682e5a9.png";